import React from "react";
import { Route, Switch } from "react-router-dom";
import MainLayout from "../components/mainLayout";
import { authRoutes } from "./auth.routes";

function Routes() {
  return (
    <Switch>
      {authRoutes}
      <Route component={MainLayout} />
    </Switch>
  );
}

export default Routes;
